module.exports = __webpack_public_path__ + "static/media/CA.deada168.png";